import TranslationListItem from "../translation/TranslationListItem";
import LookupListItemRequest from "./LookupListItemRequest";
import type LookupListItemResponse from "./LookupListItemResponse";

export default class LookupListItem {
    lookupId: number;
    parentLookupId: number | null;
    code: string;
    name: string;
    originalName: string; // Preserve original name for translation fallback
    lookupTypeId: number;
    isActive: boolean;
    translations: Array<TranslationListItem>;

    constructor(responseOrId: LookupListItemResponse | number, parentLookupId?: number | null, code?: string, name?: string, lookupTypeId?: number, isActive?: boolean, translations?: Array<TranslationListItem>) {
        if (typeof responseOrId === "object") {
            // From API response
            this.lookupId = responseOrId.lookupId;
            this.parentLookupId = responseOrId.parentLookupId;
            this.code = responseOrId.code;
            this.name = responseOrId.name;
            this.originalName = responseOrId.name; // Store original name
            this.lookupTypeId = responseOrId.lookupTypeId;
            this.isActive = responseOrId.isActive;
            this.translations = responseOrId.translations.map(t => new TranslationListItem(t.languageId, t.value, t.lookupTypeId, t.languageCode, t.objectId));
        } else {
            // From individual parameters
            this.lookupId = responseOrId;
            this.parentLookupId = parentLookupId!;
            this.code = code!;
            this.name = name!;
            this.originalName = name!; // Store original name
            this.lookupTypeId = lookupTypeId!;
            this.isActive = isActive!;
            this.translations = translations || [];
        }
    }

    toLookupListItemRequest(isAdded: boolean = false, isUpdated: boolean = false, isDeleted: boolean = false): LookupListItemRequest {
        return new LookupListItemRequest(
            this.lookupId,
            this.parentLookupId,
            this.code,
            this.name,
            this.lookupTypeId,
            isAdded,
            isUpdated,
            isDeleted,
            this.translations.map(t => t.toTranslationListItemRequest())
        );
    }
}
